import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col"
}
const _hoisted_2 = { class: "flex-1 pb-16 md:pb-0" }

import { ref, onMounted, onUnmounted, defineAsyncComponent } from 'vue';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';

// Import components
import { initializeGlobalAuth, cleanupGlobalAuth } from './composables/useAuth';
import { useConsentStore } from './stores/consentStore';
import { appEventBus } from './utils/appEventBus';
import { admobService } from './services/admobService';
import type { AuthUser } from './firebase/services/authService';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const AppHeader = defineAsyncComponent(() => import('./components/AppHeader.vue'));
const AppFooter = defineAsyncComponent(() => import('./components/AppFooter.vue'));
const MobileBottomNav = defineAsyncComponent(() => import('./components/MobileBottomNav.vue'));
const AuthModal = defineAsyncComponent(() => import('./components/AuthModal.vue'));
const GDPRConsentBanner = defineAsyncComponent(() => import('./components/GDPRConsentBanner.vue'));
const AdSenseDebug = defineAsyncComponent(() => import('./components/AdSenseDebug.vue'));
const AdDebugPanel = defineAsyncComponent(() => import('./components/AdDebugPanel.vue'));
const showAuthModal = ref(false);
// Explicitly hide ad debug panel unless you flip this to true locally
const showAdDebug = ref(false);
const consentStore = useConsentStore();

// Listen for openAuthModal events from anywhere in the app
const handleOpenAuthModal = () => {
  showAuthModal.value = true;
};

const handleAuthSuccess = (_user: AuthUser) => {
  showAuthModal.value = false;
};



// Initialize mobile platform features
const initializeMobilePlatform = async () => {
  if (Capacitor.isNativePlatform()) {
    try {
      // Configure status bar
      await StatusBar.setStyle({ style: Style.Dark });
      await StatusBar.setBackgroundColor({ color: '#1f2937' });
      
      // Hide splash screen
      await SplashScreen.hide();
      
      // Initialize AdMob
      await admobService.initialize();
      
      console.log('Mobile platform initialized');
    } catch (error) {
      console.error('Failed to initialize mobile platform:', error);
    }
  }
};

// Initialize authentication and GDPR compliance when the app mounts
onMounted(async () => {
  initializeGlobalAuth();
  appEventBus.on('openAuthModal', handleOpenAuthModal);
  
  // Initialize GDPR compliance
  await consentStore.initializeGDPR();
  
  // Initialize mobile platform features
  await initializeMobilePlatform();
});

// Cleanup authentication when the app unmounts
onUnmounted(() => {
  cleanupGlobalAuth();
  appEventBus.off('openAuthModal', handleOpenAuthModal);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AppHeader)),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(_unref(AppFooter), { class: "hidden md:block" }),
    _createVNode(_unref(MobileBottomNav)),
    _createVNode(_unref(AuthModal), {
      isOpen: showAuthModal.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (showAuthModal.value = false)),
      onSuccess: handleAuthSuccess
    }, null, 8, ["isOpen"]),
    _createVNode(_unref(GDPRConsentBanner)),
    _createVNode(_unref(AdSenseDebug)),
    (showAdDebug.value)
      ? (_openBlock(), _createBlock(_unref(AdDebugPanel), { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})